"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitlementApiImpl = void 0;
const ApiBase_1 = require("./ApiBase");
class EntitlementApiImpl extends ApiBase_1.ApiBase {
    getEntitlementService() {
        return this.getAdaptableApi().internalApi.getEntitlementService();
    }
    getEntitlementAccessLevelForModule(adaptableModule) {
        return this.getEntitlementService().getEntitlementAccessLevelForModule(adaptableModule);
    }
    isObjectReadonly(object) {
        return object.IsReadOnly;
    }
    isModuleHiddenEntitlement(adaptableModule) {
        return this.getEntitlementService().isModuleHiddenEntitlement(adaptableModule);
    }
    isModuleFullEntitlement(adaptableModule) {
        return this.getEntitlementService().isModuleFullEntitlement(adaptableModule);
    }
    isModuleReadOnlyEntitlement(adaptableModule) {
        return this.getEntitlementService().isModuleReadOnlyEntitlement(adaptableModule);
    }
}
exports.EntitlementApiImpl = EntitlementApiImpl;
